import React from 'react';

const WechatScreen = ({ 
  wechatPaymentMethod, 
  setWechatPaymentMethod,
  wechatAmount,
  setWechatAmount,
  wechatFullName,
  setWechatFullName,
  wechatQrCode,
  setWechatQrCode,
  wechatSelectedBank,
  setWechatSelectedBank,
  wechatUsdtNetwork,
  setWechatUsdtNetwork,
  exchangeRate,
  usdtToCnyRate,
  handleWechatDeposit,
  telegramUsername,
  limits
}) => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-slate-900 p-4">
    <div className="max-w-md mx-auto pt-20">
      <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl shadow-2xl p-8 border border-gray-700">
        <h2 className="text-2xl font-bold text-white mb-6">Пополнить WeChat</h2>

        <div className="space-y-6">
          <div>
            <label className="block text-sm font-semibold text-gray-300 mb-3">
              Способ оплаты
            </label>
            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={() => {
                  setWechatPaymentMethod('RUB');
                  setWechatSelectedBank('');
                }}
                className={`py-3 px-4 rounded-xl font-semibold transition-all ${
                  wechatPaymentMethod === 'RUB'
                    ? 'bg-green-600 text-white shadow-lg'
                    : 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600'
                }`}
              >
                RUB (₽)
              </button>
              <button
                onClick={() => {
                  setWechatPaymentMethod('USDT');
                  setWechatUsdtNetwork('');
                }}
                className={`py-3 px-4 rounded-xl font-semibold transition-all ${
                  wechatPaymentMethod === 'USDT'
                    ? 'bg-green-600 text-white shadow-lg'
                    : 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600'
                }`}
              >
                USDT
              </button>
            </div>
          </div>

          {wechatPaymentMethod === 'RUB' && (
            <div>
              <label className="block text-sm font-semibold text-gray-300 mb-3">
                Выберите банк
              </label>
              <div className="grid grid-cols-2 gap-3">
                {['Т-Банк', 'Сбербанк', 'ВТБ', 'Альфа Банк', 'Райффайзен Банк', 'Газпромбанк'].map(bank => (
                  <button
                    key={bank}
                    onClick={() => setWechatSelectedBank(bank)}
                    className={`py-3 px-4 rounded-xl font-semibold transition-all ${
                      wechatSelectedBank === bank
                        ? 'bg-green-600 text-white shadow-lg'
                        : 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600'
                    }`}
                  >
                    {bank}
                  </button>
                ))}
              </div>
            </div>
          )}

          {wechatPaymentMethod === 'USDT' && (
            <div>
              <label className="block text-sm font-semibold text-gray-300 mb-3">
                Выберите сеть
              </label>
              <div className="grid grid-cols-1 gap-3">
                <button
                  onClick={() => setWechatUsdtNetwork('TRC-20')}
                  className={`py-3 px-4 rounded-xl font-semibold transition-all ${
                    wechatUsdtNetwork === 'TRC-20'
                      ? 'bg-green-600 text-white shadow-lg'
                      : 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600'
                  }`}
                >
                  TRC-20 (Tether)
                </button>
                <button
                  onClick={() => setWechatUsdtNetwork('Bybit')}
                  className={`py-3 px-4 rounded-xl font-semibold transition-all ${
                    wechatUsdtNetwork === 'Bybit'
                      ? 'bg-green-600 text-white shadow-lg'
                      : 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600'
                  }`}
                >
                  Bybit (Внутренний перевод)
                </button>
              </div>
            </div>
          )}

          {telegramUsername && (
            <div>
              <label className="block text-sm font-semibold text-gray-300 mb-2">
                Telegram username
              </label>
              <div className="w-full px-4 py-3 bg-gray-900/30 border-2 border-gray-700 rounded-xl text-gray-400">
                @{telegramUsername}
              </div>
              <p className="mt-2 text-xs text-gray-500">
                Ваш Telegram username будет сохранен с заявкой
              </p>
            </div>
          )}

          <div>
            <label className="block text-sm font-semibold text-gray-300 mb-2">
              Сумма в юанях (CNY)
            </label>
            <input
              type="number"
              value={wechatAmount}
              onChange={(e) => setWechatAmount(e.target.value)}
              placeholder={`Введите сумму (${limits?.minAmount || 500} - ${limits?.maxAmount?.toLocaleString() || '20,000'})`}
              min={limits?.minAmount || 500}
              max={limits?.maxAmount || 20000}
              className="w-full px-4 py-3 bg-gray-900/50 border-2 border-gray-700 rounded-xl focus:border-green-500 focus:outline-none transition-all text-white placeholder-gray-500"
            />
            <div className="mt-2 flex items-center justify-between text-xs">
              <span className="text-gray-500">
                Минимум: <span className="text-yellow-400 font-semibold">{limits?.minAmount?.toLocaleString() || 500} ¥</span>
              </span>
              <span className="text-gray-500">
                Максимум: <span className="text-yellow-400 font-semibold">{limits?.maxAmount?.toLocaleString() || '20,000'} ¥</span>
              </span>
            </div>
            {wechatAmount && wechatPaymentMethod && exchangeRate && usdtToCnyRate && (
              <p className="mt-2 text-sm text-gray-400">
                К оплате: <span className="font-bold text-green-400">
                  {wechatPaymentMethod === 'RUB' 
                    ? `${(parseFloat(wechatAmount) * exchangeRate).toFixed(2)} ₽`
                    : `${(parseFloat(wechatAmount) / usdtToCnyRate).toFixed(2)} USDT`}
                </span>
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-300 mb-2">
              Имя и Фамилия (латиницей)
            </label>
            <input
              type="text"
              value={wechatFullName}
              onChange={(e) => setWechatFullName(e.target.value)}
              placeholder="Например: Ivan Ivanov"
              className="w-full px-4 py-3 bg-gray-900/50 border-2 border-gray-700 rounded-xl focus:border-green-500 focus:outline-none transition-all text-white placeholder-gray-500"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-300 mb-2">
              QR код
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setWechatQrCode(e.target.files[0])}
              className="w-full px-4 py-3 bg-gray-900/50 border-2 border-gray-700 rounded-xl focus:border-green-500 focus:outline-none transition-all text-gray-300 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-green-600 file:text-white hover:file:bg-green-500"
            />
            <p className="mt-2 text-xs text-gray-500">
              Загрузите скриншот QR кода вашего WeChat аккаунта
            </p>
          </div>

          <button
            onClick={handleWechatDeposit}
            className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl py-4 font-semibold shadow-lg hover:shadow-xl hover:from-green-400 hover:to-emerald-500 transition-all"
          >
            Создать заявку
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default WechatScreen;

